import InputEditor from './InputEditor'
export default InputEditor
